import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Button, Typography } from 'foundations-library/components'
import { TypographyType } from 'foundations-library/types'
import EditButton from './EditButton'

const jss = () => ({
    titleContainer: {
        marginBottom: 40,
        display: 'flex',
        justifyContent: 'space-between'
    },
    buttonsContainer: {
        display: 'flex',
        gap: 10
    }
})

type PropsType = {
    status?: string
    mode?: 'preview' | 'edit'
    onClickEdit?: () => unknown
    onClickSubmitPaymentFailed?: () => unknown
} & TypographyType

const useStyles = makeStyles(jss)

/**
 *
 */
const StepTitle = ({
    status,
    mode,
    onClickEdit,
    onClickSubmitPaymentFailed,
    ...props
}: PropsType): JSX.Element => {
    const styles = useStyles()
    return <div className={styles.titleContainer}>
        <Typography variant='h5' {...props} />
        <div className={styles.buttonsContainer} data-testid='step-title'>
            {
                mode === 'preview' &&
                status &&
                <EditButton status={status} onClick={(onClickEdit)} />
            }
            {
                status === 'payment-failed'
                    ? <Button onClick={onClickSubmitPaymentFailed}>Submit</Button>
                    : <></>
            }
        </div>
    </div>
}

export default StepTitle
